import { USERS } from "./users";
import { POSTS } from "./posts";
import { REELS } from "./reels";
import { MOVIES } from "./movies";
import { COLLECTIONS } from "./collections";
import { NOTIFICATIONS } from "./notifications";

export { USERS, POSTS, REELS, MOVIES, COLLECTIONS, NOTIFICATIONS };

export const getUserById = (id: string) => USERS.find(u => u.id === id);
export const getUserByUsername = (username: string) => USERS.find(u => u.username === username);
export const getPostById = (id: string) => POSTS.find(p => p.id === id);
export const getPostsByAuthor = (authorId: string) => POSTS.filter(p => p.authorId === authorId);
export const getReelById = (id: string) => REELS.find(r => r.id === id);
export const getReelsByAuthor = (authorId: string) => REELS.filter(r => r.authorId === authorId);
export const getMovieById = (id: string) => MOVIES.find(m => m.id === id);
export const getMoviesByIds = (ids: string[]) => ids.map(getMovieById).filter((m): m is NonNullable<typeof m> => Boolean(m));
export const getCollection = (slug: string) => COLLECTIONS.find(c => c.slug === slug);
